import React from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Inmuebles from './pages/Inmuebles';
import Inquilinos from './pages/Inquilinos';
import Contratos from './pages/Contratos';
import Inmobiliarias from './pages/Inmobiliarias';
import Pagos from './pages/Pagos';
import CuentaCorriente from './pages/CuentaCorriente';
import './App.css';

function PrivateRoute({ children }) {
  const { usuario, cargando } = useAuth();
  if (cargando) return <div className="loading">Cargando...</div>;
  return usuario ? children : <Navigate to="/login" />;
}

function AppLayout() {
  const { usuario, logout } = useAuth();

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <h2>ERP Inmuebles</h2>
          <span>Punta del Este</span>
        </div>
        <nav>
          <NavLink to="/" end>Dashboard</NavLink>
          <NavLink to="/inmuebles">Inmuebles</NavLink>
          <NavLink to="/inquilinos">Inquilinos</NavLink>
          <NavLink to="/contratos">Contratos</NavLink>
          <NavLink to="/inmobiliarias">Inmobiliarias</NavLink>
          <NavLink to="/pagos">Pagos</NavLink>
          <NavLink to="/gastos">Gastos</NavLink>
          <NavLink to="/informes">Informes</NavLink>
        </nav>
        <div className="sidebar-footer">
          <span>{usuario?.nombre} {usuario?.apellido}</span>
          <button onClick={logout} className="logout-btn">Cerrar sesión</button>
        </div>
      </aside>
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/inmuebles" element={<Inmuebles />} />
          <Route path="/inquilinos" element={<Inquilinos />} />
          <Route path="/contratos" element={<Contratos />} />
          <Route path="/inmobiliarias" element={<Inmobiliarias />} />
          <Route path="/pagos" element={<Pagos />} />
          <Route path="/cuenta-corriente/:contratoId" element={<CuentaCorriente />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginRoute />} />
        <Route path="/*" element={
          <PrivateRoute>
            <AppLayout />
          </PrivateRoute>
        } />
      </Routes>
    </Router>
  );
}

function LoginRoute() {
  const { usuario, cargando } = useAuth();
  if (cargando) return <div className="loading">Cargando...</div>;
  return usuario ? <Navigate to="/" /> : <Login />;
}

export default App;
